import React from "react";
import PropTypes from "prop-types";
import { Button, Icon, TextField } from "@material-ui/core";
import "./ChatInput.css";

class ChatInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = { chatInput: "" };
	}

	submitHandler(e) {
		e.preventDefault();
		// Clear the input box
		this.setState({ chatInput: "" });

		// Call the onSend callback with the chatInput message
		this.props.addMessage(this.state.chatInput);
	}

	textChangeHandler(event) {
		this.setState({ chatInput: event.target.value });
	}

	render() {
		return (
			<div className="row col-lg-12 col-md-12 col-sm-12 col-12 right">
				<TextField
					id="message"
					label={"Message"}
					className="full_size col-lg-10 col-md-10 col-sm-9 col-9"
					disabled={this.props.disabled}
					value={this.state.chatInput}
					onChange={this.textChangeHandler.bind(this)}
					onKeyPress={(ev) => {
						if (ev.key === "Enter") {
							this.submitHandler(ev);
							ev.target.blur();
						}
					}}
				/>
				<Button
					className="button col-lg-2 col-md-2 col-sm-3 col-3"
					color="primary"
					type="submit"
					onClick={this.submitHandler.bind(this)}
					disabled={this.props.disabled}
				>
					<Icon>play_arrow</Icon>Envoyer 
				</Button>
			</div>
		);
	}
}

ChatInput.propTypes = {
	addMessage: PropTypes.func,
	disabled: PropTypes.bool,
};

export default ChatInput;
